const EmailIcon = () => {
  return (
    <svg width="48" height="36" viewBox="0 0 48 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_19_2)">
        <path
          d="M0 4.23112V3C0 2.20435 0.316071 1.44129 0.87868 0.87868C1.44129 0.316071 2.20435 0 3 0L45 0C45.7956 0 46.5587 0.316071 47.1213 0.87868C47.6839 1.44129 48 2.20435 48 3V4.23112L24 19.2311L0 4.23112ZM24.795 22.2724C24.5565 22.4212 24.2811 22.5001 24 22.5001C23.7189 22.5001 23.4435 22.4212 23.205 22.2724L0 7.76887V33C0 33.7956 0.316071 34.5587 0.87868 35.1213C1.44129 35.6839 2.20435 36 3 36H45C45.7956 36 46.5587 35.6839 47.1213 35.1213C47.6839 34.5587 48 33.7956 48 33V7.76887L24.795 22.2724Z"
          fill="#60AFED"
        />
      </g>
      <defs>
        <clipPath id="clip0_19_2">
          <rect width="48" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EmailIcon;
